<tt-page *ngIf="!!setting">
    <tt-page-heading ttModel="p2_m_equipments" ttTranslate></tt-page-heading>

    <tt-tabs [(ttSelectedId)]="selectedBgEquipmentsMain">
        <tt-tab ttId="TOUCH" ttLabel="bg_equipments_main_touch"></tt-tab>
        <tt-tab ttId="GRID" ttLabel="bg_equipments_main_grid"></tt-tab>
    </tt-tabs>

    <div *ngIf="selectedBgEquipmentsMain === 'TOUCH'">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-6 p-5">
                <tt-input ttRememberId="w_equipments.searchtext" ttLabel="searchtext" ttFocus="false" [(ttModel)]="setting.searchtext" ttShowClearButton></tt-input>
            </tt-card>

            <tt-card class="col-xs-12 col-md-6 p-5">
                <tt-button-goto ttText="add_new_equipmentedit" ttGoto="equipmentedit" [ttGotoParms]="{ equipment_id: '0' }" ttIcon="far fa-plus"></tt-button-goto>
            </tt-card>
        </div>

        <tt-list class="col-xs-12 col-md-6 p-5" [ttData]="itemsListEquipments" [ttFilter]="setting.searchtext"></tt-list>
    </div>

    <tt-grid *ngIf="selectedBgEquipmentsMain === 'GRID' && !!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
